import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AdmissionOverview = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */
    const [section, setSection] = useState({
        heading: "",
        admissionOverviewContent: "",
    });

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/admission_page/get_admission_overview_content/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const admissionContent  = res.data.data.section;
                console.log(admissionContent?.heading);
                setSection({
                    heading: admissionContent?.heading || "",
                    admissionOverviewContent: admissionContent?.admission_overview_content || "",
                });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- INPUT HANDLERS ---------------- */
    const handleSectionChange = (e) => {
        setSection({ ...section, [e.target.name]: e.target.value });
    };

    /* ---------------- SUBMIT ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(section));

            const res = await axios.post(
                `${baseAPIUrl}admin/admission_page/add_edit_admission_overview_content`,
                formData,
                { withCredentials: true }
            );

            fetchContent();
            scrollToTop();
            setMessage(res.data.msg);
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };


    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">
                                Admission Overview Section
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="/admin/dashboard">Dashboard</a>
                                </li>
                                <li className="breadcrumb-item active">
                                    Admission page
                                </li>
                                <li className="breadcrumb-item active">
                                    Admission overview
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h4>Edit Admission overview section</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                {message && (
                                    <p className="text-center text-danger">{message}</p>
                                )}

                                {/* Section Fields */}
                                {/* Heading */}
                                <div className="form-group">
                                    <label>Heading</label>
                                    <input
                                        type="text"
                                        name="heading"
                                        className="form-control"
                                        placeholder="Heading title"
                                        value={section.heading}
                                        onChange={handleSectionChange}
                                    />
                                </div>

                                {/* Admission overview section content 1*/}
                                <div className="form-group">
                                    <label>Admission overview section content</label>
                                    <textarea
                                        name="admissionOverviewContent"
                                        rows="15"
                                        className="form-control"
                                        value={section.admissionOverviewContent}
                                        placeholder="Admission overview section content"
                                        onChange={handleSectionChange}
                                    />
                                </div>

                            </div>

                            <div className="card-footer">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AdmissionOverview;
